import React from 'react';
import coverbackground from '../../assets/air-bg.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollAtmosphere extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        tag="EXPLORE"
        description="Atmosphere"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollAtmosphere;